import { StyledButton, RotatingLoaderIcon } from "./Styles";

export function Button(
  props: React.ButtonHTMLAttributes<HTMLButtonElement> & {
    isLoading?: boolean;
  }
) {
  const { isLoading, ...buttonProps } = props;
  return (
    <StyledButton disabled={buttonProps.disabled || isLoading} $isLoading={isLoading} {...buttonProps}>
      {isLoading && <RotatingLoaderIcon />}
      {props.children}
    </StyledButton>
  );
}
